<template>
  <div>
    <v-timeline dense>
      <v-timeline-item
        v-for="(item, i) in items"
        :key="i"
        :color="item.color"
        :icon="item.icon"
        fill-dot
        small
      >
        <v-card
          outlined
          class="d-flex"
          :color="item.complete ? item.color : 'grey lighten-4'"
          :dark="item.complete"
        >
          <v-card-text
            :class="{'border': !item.complete}"
            class="d-flex align-center"
          >
            <strong
              :class="!item.complete ? 'primary--text': 'white--text'"
            >
              {{ item.text }}
            </strong>
          </v-card-text>

          <v-spacer />

          <div
            :class="item.color"
            class="pl-1"
          />
        </v-card>
      </v-timeline-item>
    </v-timeline>

    <v-btn
      v-if="routeDetails.status !== 'Completed'"
      :loading="isSubmiting"
      dark
      depressed
      color="green"
      @click="markAsDelivered"
    >
      <v-icon left>
        mdi-check
      </v-icon>
      <span> Mark as Completed </span>
    </v-btn>

    <v-snackbar
      v-model="snackbar.isOpen"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { completeRoute } from '@/endpoints';

export default {
  props: {
    routeDetails: {
      type: Object,
      default() {
        return {
          status: 'Accepted',
        };
      },
    },
  },
  data() {
    return {
      isSubmiting: false,
      snackbar: {
        text: '',
        isOpen: false,
        color: 'green',
      },
    };
  },
  computed: {
    items() {
      return [
        {
          text: 'Accepted',
          color: 'primary',
          icon: 'mdi-truck',
          complete: this.isAccepted,
        },
        {
          text: 'Completed',
          color: 'green',
          icon: 'mdi-truck-check',
          complete: this.isDelivered,
        },
      ];
    },
    isAccepted() {
      return this.isDelivered || this.routeDetails.status === 'Accepted';
    },
    isDelivered() {
      return this.routeDetails.status === 'Completed';
    },
  },
  methods: {
    markAsDelivered() {
      this.isSubmiting = true;

      const data = {
        route_id: this.routeDetails.id,
      };

      this.axios
        .post(completeRoute, data)
        .then(() => {
          this.isSubmiting = false;

          this.displaySnackbar({
            text: 'Successfully marked route as Completed.',
            color: 'green',
          });

          this.$emit('route-updated');
        })
        .catch(() => {
          this.isSubmiting = false;

          this.displaySnackbar({
            text: 'Could not mark route as Completed.',
            color: 'red',
          });
        });
    },
    displaySnackbar({ text, color }) {
      this.snackbar = {
        text,
        color,
        isOpen: true,
      };
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #e6e6e6 !important;
  border-left: none !important;
}
</style>
